import { EvesIconButton } from "@/common/components/atoms/iconButton/iconButton";
import FilterSelector from "@/common/components/filterSelector";
import { ITableActionMenuModel } from "@/common/components/organisms/table/actionMenu";
import DataTable from "@/common/components/organisms/table/dataTable";
import { CellStatus } from "@/common/components/organisms/table/dataTableCells";
import { SearchBox } from "@/common/components/searchBox";
import { Content } from "@/common/components/templates/content/content";
import {
  DefaultPageSize,
  filterSelector,
  UserInErrorTypeDetail,
} from "@/common/constants/constants";
import {
  UserInErrorType,
  UserStatus,
  Filters,
  UpdatedUserRole,
  ComponentKeys,
} from "@/common/enums/enums";
import { getComponentValueSafe } from "@/common/utils/componentListHelper";
import { IContextPropsModel, withContext } from "@/common/utils/withContext";
import { IUserInErrorModel } from "@/modules/chargingStation/shared/models/users";
import { getUsersInError } from "@/services/chargingStations";
import { UserInErrorModel } from "@/services/models/chargingStation";
import { Edit, InfoOutlined, Store } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { CSSProperties, useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import UserForm from "../../shared/components/UserForm";
import UserAssignSite from "./components/assignSite";
import { columnsType } from "@/common/models/model";
import { useTranslation } from "react-i18next";
import { isActive } from "@/common/utils/utils";
import ButtonGroup from "@/common/components/molecules/buttonGroup/buttonGroup";
import { setLoader } from "@/store/app/reducer";
import store from "@/store";

const UserInError = (props: IContextPropsModel) => {
  const { t: translate } = useTranslation();
  const isOrganizationActive = isActive(getComponentValueSafe(ComponentKeys.ORGANIZATION));
  const [showfilter, setShowfilter] = useState<boolean>(false);

  const [state, setStateData] = useState({
    rows: [],
    totalRowsCount: 0,
    limit: DefaultPageSize,
    page: 0,
    defaultIssuer: true,
    defaultPageSize: DefaultPageSize,
    isResetBtnDisabled: true,
    issuer: true,
    issuerName: "",
    search: "",
    sortFields: "",
    isAssignToSiteModal: false,
    userId: "",
    userName: "",
    firstName: "",
    showUserForm: false,
    isErrorDetailModalOpen: false,
    errorCode: "",
    chargingStationErrorCode: "",
    role: "",
    projectFields: [],
  } as IUserInErrorModel);

  const columns: columnsType[] = [
    {
      id: "actions",
      label: `${translate("general.actions")}`,
      minWidth: 90,
      textAlign: "center",
      maxWidth: 180,
      projectField: "action",
    },
    {
      id: "status",
      label: `${translate("users.status")}`,
      minWidth: 60,
      allowSort: true,
      textAlign: "center",
      maxWidth: 130,
      sortKey: "status",
      projectField: "status",
      enableTooltip: false,
    },
    {
      id: "role",
      label: `${translate("users.role")}`,
      minWidth: 90,
      allowSort: true,
      textAlign: "center",
      maxWidth: 120,
      sortKey: "role",
      projectField: "role",
      enableTooltip: false,
    },
    {
      id: "name",
      label: `${translate("users.last_name")}`,
      minWidth: 120,
      allowSort: true,
      sortKey: "name",
      textAlign: "left",
      maxWidth: 210,
      projectField: "name",
    },
    {
      id: "firstName",
      label: `${translate("users.first_name")}`,
      minWidth: 120,
      allowSort: false,
      textAlign: "left",
      maxWidth: 210,
      sortKey: "firstName",
      projectField: "firstName",
      headerAlign: "left",
    },
    {
      id: "email",
      label: `${translate("users.email")}`,
      minWidth: 60,
      allowSort: false,
      sortKey: "email",
      maxWidth: 200,
      textAlign: "left",
      projectField: "email",
      headerAlign: "left",
    },
    {
      id: "errorDetail",
      label: `${translate("general.info")}`,
      minWidth: 60,
      allowSort: false,
      textAlign: "center",
      maxWidth: 100,
      projectField: "errorCodeDetails",
      enableTooltip: false,
    },
    {
      id: "errorCode",
      label: `${translate("general.error")}`,
      minWidth: 210,
      allowSort: false,
      sortKey: "errorCode",
      textAlign: "left",
      headerAlign: "left",
      maxWidth: 300,
      projectField: "errorCodeyyy",
      enableTooltip: false,
    },
  ];

  const openAssignToSiteModal = (record: any) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        userId: record.id,
        userName: record.name,
        firstName: record.firstName,
        isAssignToSiteModal: true,
      };
    });
  };

  const updateUserForm = (record: any) => {
    setStateData((currentData: any) => {
      return {
        ...currentData,
        showUserForm: true,
        userId: record.id,
      };
    });
  };

  const primaryActions: ITableActionMenuModel[] = [
    {
      title: () => `${translate("general.edit")}`,
      icon: () => Edit,
      iconColor: "primary",
      onClick: updateUserForm,
    },
    {
      title: () => `${translate("general.tooltips.assign_site")}`,
      icon: () => Store,
      iconColor: "primary",
      visible: () => true,
      onClick: openAssignToSiteModal,
      "data-cy": "assign-to-site-modal-btn",
    },
  ];

  const { refetch: fetchGetUsersInError } = useQuery(
    "UsersInError",
    () => {
      return getUsersInError(getUsersInErrorParams());
    },
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess: (data: any) => {
        if (data) {
          const usersInErrorData = data.result.map(
            (d) => new UserInErrorModel(d)
          );

          setStateData((currentData) => {
            return {
              ...currentData,
              rows: usersInErrorData,
              totalRowsCount: data.count,
              projectFields: data.projectFields && [...data.projectFields],
            };
          });
        }
      },
    }
  );

  const loadUserInErrorList = async () => {
    store.dispatch(setLoader(true));
    try {
      await fetchGetUsersInError(); // API call
    } finally {
      store.dispatch(setLoader(false));
    }
  };

  useEffect(() => {
    loadUserInErrorList();
  }, [
    state.sortFields,
    state.limit,
    state.page,
    state.search,
    state.errorCode,
    state.isResetBtnDisabled,
    state.role,
  ]);

  const getUsersInErrorParams = (): any => {
    const userInErrorGetParams: any = {
      Limit: state.limit,
      SortFields: state.sortFields,
      Page: state.page + 1,
    };

    if (state.search !== "") {
      userInErrorGetParams["Search"] = state.search;
    }

    if (state.role !== "") {
      userInErrorGetParams["Role"] = state.role;
    }
    if (state.errorCode !== "") {
      userInErrorGetParams["ErrorType"] = state.errorCode;
    }
    return userInErrorGetParams;
  };

  const onUserInErrorChange = (params: any) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        sortFields: params.sortFields,
      };
    });
  };

  const onPageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        page: newPage,
      };
    });
  };
  const onRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        page: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const onRoleSelect = (selectedItems: any) => {
    const sortedItems = selectedItems.sort((a, b) => a.localeCompare(b));
    const combinedRoles = sortedItems
      ?.map((item) => item.charAt(0).toUpperCase())
      .join("|");
    setStateData((currentData) => {
      return {
        ...currentData,
        role: combinedRoles,
        isResetBtnDisabled: false,
      };
    });
    if (selectedItems.length === 0) {
      setStateData((currentData) => {
        return {
          ...currentData,
          isResetBtnDisabled: !state.search && !state.errorCode,
        };
      });
    }
  };

  const RoleCell = (row: any) => {
    const userRole = row.role;
    if (userRole === UpdatedUserRole.SUPER_ADMIN) {
      return (
        <div>
          <p>{translate("users.role_super_admin")}</p>
        </div>
      );
    } else if (userRole === UpdatedUserRole.CPO_ADMIN) {
      return (
        <div>
          <p>{translate("users.role_cpo_admin")}</p>
        </div>
      );
    } else if (userRole === UpdatedUserRole.ADMIN) {
      return (
        <div>
          <p>{translate("users.role_admin")}</p>
        </div>
      );
    } else if (userRole === UpdatedUserRole.AGENT) {
      return (
        <div>
          <p>{translate("users.role_agent")}</p>
        </div>
      );
    } else if (userRole === UpdatedUserRole.SITE_ADMIN) {
      return (
        <div>
          <p>{translate("users.role_site_admin")}</p>
        </div>
      );
    } else if (userRole === UpdatedUserRole.SITE_OWNER) {
      return (
        <div>
          <p>{translate("users.role_site_owner")}</p>
        </div>
      );
    }

    return <p>-</p>;
  };

  const ErrorCodeCell = (row: any) => {
    const errorColor = "#d32f2f";
    const userErrorCode: string = row.errorCode;
    let errorMessage: string;

    switch (userErrorCode) {
      case UserInErrorType.FAILED_BILLING_SYNCHRO:
        errorMessage = translate(
          UserInErrorTypeDetail[UserInErrorType.FAILED_BILLING_SYNCHRO].title
        );
        break;
      case UserInErrorType.INACTIVE_USER_ACCOUNT:
        errorMessage = translate(
          UserInErrorTypeDetail[UserInErrorType.INACTIVE_USER_ACCOUNT].title
        );
        break;
      case UserInErrorType.NOT_ACTIVE:
        errorMessage = translate(
          UserInErrorTypeDetail[UserInErrorType.NOT_ACTIVE].title
        );
        break;
      case UserInErrorType.NOT_ASSIGNED:
        errorMessage = translate(
          UserInErrorTypeDetail[UserInErrorType.NOT_ASSIGNED].title
        );
        break;
      default:
        errorMessage = "";
    }
    return <p style={{ color: errorColor }}>{errorMessage}</p>;
  };

  const Statuscell = (row: any) => {
    let statusLabel: string;
    let statusType: string;
    switch (row.status) {
      case UserStatus.ACTIVE:
        statusLabel = `${translate("users.status_active")}`;
        statusType = "Available";
        break;
      case UserStatus.PENDING:
        statusLabel = `${translate("users.status_pending")}`;
        statusType = "Pending";
        break;
      case UserStatus.BLOCKED:
        statusLabel = `${translate("users.status_blocked")}`;
        statusType = "Faulted";
        break;
      case UserStatus.DELETED:
        statusLabel = `${translate("general.invoices.status.deleted")}`;
        statusType = "Faulted";
        break;
      case UserStatus.LOCKED:
        statusLabel = `${translate("users.status_locked")}`;
        statusType = "Faulted";
        break;
      case UserStatus.INACTIVE:
        statusLabel = `${translate("users.status_inactive")}`;
        statusType = "Faulted";
        break;

      default:
        statusLabel = `${translate("users.status_inactive")}`;
        statusType = "Unavailable";
    }

    return <CellStatus label={statusLabel} type={statusType} />;
  };

  const setErrorDetailModalOpen = (errorCode: string) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        chargingStationErrorCode: errorCode,
        //isErrorDetailModalOpen: true,
      };
    });
    showUserErrorDialog(errorCode);
  };

  const ErrorCodeDetailsCell = (row: any) => {
    return (
      <>
        <EvesIconButton
          icon={InfoOutlined}
          color="error"
          onClick={() => setErrorDetailModalOpen(row.errorCode)}
        />
      </>
    );
  };

  const searchBoxRef = useRef<any>();
  const onClickresetFilters = () => {
    searchBoxRef?.current?.resetSearch();
    setStateData((currentData) => {
      return {
        ...currentData,
        search: "",
        role: "",
        isResetBtnDisabled: true,
        errorCode: "",
      };
    });
  };

  const onFilterApplied = (searchText: string) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        search: searchText,
        isResetBtnDisabled: !searchText && !state.role && !state.errorCode,
      };
    });
  };

  const onErrorSelect = (selectedItems: any) => {
    const errorFilter: string = selectedItems
      .map((i) => filterSelector[Filters.ERROR].value[i])
      .join("|");

    setStateData((currentData) => {
      return {
        ...currentData,
        errorCode: errorFilter,
        isResetBtnDisabled: false,
      };
    });
    if (selectedItems.length === 0) {
      setStateData((currentData) => {
        return {
          ...currentData,
          isResetBtnDisabled: !state.search && !state.role,
        };
      });
    }
  };

  const onSiteAssignModalClose = () => {
    setStateData((currentData) => {
      return {
        ...currentData,
        isAssignToSiteModal: false,
      };
    });
  };

  const onFormClose = () => {
    setStateData((currentData) => {
      return {
        ...currentData,
        showUserForm: false,
      };
    });
  };

  const resetUserForm = (val: any) => {
    setStateData((currentData) => {
      return {
        ...currentData,
        userId: val,
      };
    });
  };
  const UserErrorDialogBody = (data: any) => {
    return (
      <>
        <Grid container direction={"row"} fontSize={"14px"} width={"652px"}>
          <Grid item xs={3}>
            <b>{translate("general.description")}</b>
          </Grid>
          <Grid item xs={9}>
            {translate(UserInErrorTypeDetail[data].description)}
          </Grid>
          <Grid item xs={3}>
            <b>{translate("errors.action")}</b>
          </Grid>
          <Grid item xs={9}>
            {translate(UserInErrorTypeDetail[data].action)}
          </Grid>
        </Grid>
      </>
    );
  };

  const showUserErrorDialog = (errorCode) => {
    props.dialogService?.showConfirm({
      title: `${translate(UserInErrorTypeDetail[errorCode].title)}`,
      confirmType: "CLOSE",
      body: () => UserErrorDialogBody(errorCode),
    });
  };

  const alignStyle: CSSProperties = { alignItems: "flex-end !important" };

  return (
    <>
      <Content
        contentTop={
          <Grid>
            <Grid
              container
              item
              display={"flex"}
              justifyContent={"space-between"}
            >
              <Grid item xs={10} lg={8} sm={6} md={8} xl={9}>
                {showfilter && (
                  <Grid
                    container
                    item
                    spacing={2}
                    rowSpacing={1}
                    sx={alignStyle}
                  >
                    <Grid
                      data-cy="role-dropdown-field"
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={4}
                      xl={6}
                    >
                      <FilterSelector
                        filterOption={Filters.ROLES}
                        defaultIssuer={state.defaultIssuer}
                        isResetBtnDisabled={state.isResetBtnDisabled}
                        onChange={onRoleSelect}
                      />
                    </Grid>
                    {isOrganizationActive && (
                      <Grid item xs={12} sm={6} md={4} lg={4} xl={6}>
                        <FilterSelector
                          label={`${translate("general.error")}`}
                          filterOption={Filters.ERROR}
                          defaultIssuer={state.defaultIssuer}
                          isResetBtnDisabled={state.isResetBtnDisabled}
                          onChange={onErrorSelect}
                        />
                      </Grid>
                    )}

                    <Grid
                      data-cy="search-field"
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={8}
                      xl={6}
                    >
                      <SearchBox
                        ref={searchBoxRef}
                        onChange={onFilterApplied}
                        onRemoveClick={fetchGetUsersInError}
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <Grid item gap={"10px"} mt={1} xs={2} sm={6} md={4} lg={4} xl={3}>
                <ButtonGroup
                  {...{
                    showfilter,
                    setShowfilter,
                    resetFilters: onClickresetFilters,
                    onRefresh: () => {
                      fetchGetUsersInError();
                    },
                    state,
                    isExport: true,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        }
        contentBody={
          <DataTable
            data-cy="users-in-error-grid-main"
            rows={state.rows}
            columns={columns}
            actionsMenu={primaryActions}
            totalRowsCount={state.totalRowsCount}
            onChange={onUserInErrorChange}
            defaultSortField={state.sortFields}
            projectFields={state.projectFields}
            count={state.totalRowsCount}
            limit={state.limit}
            page={state.page}
            tablePagination={true}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
          >
            <Statuscell slot="status" />
            <RoleCell slot="role" />
            <ErrorCodeDetailsCell slot="errorDetail" />
            <ErrorCodeCell slot="errorCode" />
          </DataTable>
        }
      ></Content>
      {state.isAssignToSiteModal && (
        <UserAssignSite
          userId={state.userId}
          userName={state.userName}
          firstName={state.firstName}
          showModal={state.isAssignToSiteModal}
          onClose={onSiteAssignModalClose}
          notificationService={props.notificationService}
          data-cy="inerror-site-assign-main"
        />
      )}
      {state.showUserForm && (
        <UserForm
          statusRequired={false}
          userId={state.userId}
          resetUserForm={resetUserForm}
          showUserForm={state.showUserForm}
          onFormClose={onFormClose}
          fetchAllUsers={fetchGetUsersInError}
        />
      )}
    </>
  );
};

export default withContext(UserInError);
